<template>
  <nuxt-link
    class="notification-panel__notification-link"
    :to="route"
    @click="markAsReadAndHandleClick"
  >
    <div class="notification-panel__notification-content-title">
      <i18n-t keypath="conversationTranscribedNotification.title" tag="span">
        <template #agent>
          <strong>{{ notification.data.agent || $t('conversationTranscribedNotification.theAi') }}</strong>
        </template>
        <template #count>
          <strong>{{ notification.data.count }}</strong>
        </template>
        <template #table>
          <strong>{{ notification.data.table_name }}</strong>
        </template>
        <template #label>
          <strong>{{ notification.data.source_label || $t('conversationTranscribedNotification.audio') }}</strong>
        </template>
      </i18n-t>
    </div>
    <div class="notification-panel__notification-content-desc">
      {{ $t('conversationTranscribedNotification.hint') }}
    </div>
  </nuxt-link>
</template>

<script>
import notificationContent from '@baserow/modules/core/mixins/notificationContent'

export default {
  name: 'ConversationTranscribedNotification',
  mixins: [notificationContent],
  emits: ['close-panel'],
  methods: {
    handleClick() {
      this.$emit('close-panel')
    },
  },
}
</script>
